import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

const isIframeContext = () => {
  try {
    return window.self !== window.top;
  } catch {
    return false;
  }
};

const getConversationIdForIframeRoute = to => {
  const { params = {}, name } = to;

  if (params.conversationId || params.conversation_id) {
    return params.conversationId || params.conversation_id;
  }

  if (name === 'inbox_view_conversation' && params.type === 'conversation') {
    return params.id;
  }

  return null;
};

const getEmbeddedConversationRedirect = to => {
  if (!isIframeContext() || to.meta?.isIframe) {
    return null;
  }

  const conversationId = getConversationIdForIframeRoute(to);
  if (!conversationId || !to.params?.accountId) {
    return null;
  }

  return {
    name: 'conversation_iframe',
    params: {
      accountId: to.params.accountId,
      conversationId,
    },
    query: to.query,
  };
};

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;
  const embeddedConversationRedirect = getEmbeddedConversationRedirect(to);

  if (embeddedConversationRedirect) {
    return next(embeddedConversationRedirect);
  }

  if (!isLoggedIn) {
    const redirectUrl = to.fullPath
      ? `?redirect_url=${encodeURIComponent(to.fullPath)}`
      : '';
    window.location.assign(`/app/login${redirectUrl}`);
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
